// Single source for the analytics enable switch. Env-only — safe to import
// from both client and server. NODE_ENV is "production" on Vercel previews too,
// so a dedicated flag keeps dev + preview clean: set
// NEXT_PUBLIC_POSTHOG_ENABLED=true in Vercel Production only.
export function isPostHogEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_POSTHOG_ENABLED === "true" &&
    Boolean(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN)
  )
}

export function isDev(): boolean {
  return process.env.NODE_ENV !== "production"
}

// Production Meta Pixel ID is 1618386633344453 — it is NOT hardcoded on
// purpose: the env var is what decides whether the pixel exists at all.
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID

/**
 * Gate for the Meta Pixel, same spirit as `isPostHogEnabled` but stricter,
 * because the blast radius is different: PostHog noise from a preview is dirty
 * data, while a Meta event from a preview actively poisons the optimization
 * and lookalike models of a live ad account.
 *
 * Two locks:
 * 1. No `NEXT_PUBLIC_FACEBOOK_PIXEL_ID` → no pixel. Set it in the Vercel
 *    **Production** scope only.
 * 2. Even with the ID present, never outside a production build, and never on
 *    a Vercel preview/development deployment. `NEXT_PUBLIC_VERCEL_ENV` comes
 *    from Vercel's system env vars; when they are not exposed it is undefined
 *    and only the NODE_ENV lock applies.
 */
export function isMetaPixelEnabled(): boolean {
  if (!META_PIXEL_ID) return false
  if (process.env.NODE_ENV !== "production") return false
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV
  return !vercelEnv || vercelEnv === "production"
}
